import React from 'react';
import { Button, CardText, Card, CardHeader, Row, CardTitle, Col, Container } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink, Input } from 'reactstrap';
import Select from 'react-select';
import { downloadExcel } from "react-export-table-to-excel";
import { withRouter } from 'react-router-dom';
import './css/fonts.css';
import url from './variables/url.js';
const local = url.localBack;

function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images
}

const images = importAll(require.context('./icons', false, /\.(png|jpe?g|svg)$/));
const header = ["Profesor", "Actividad","Tipo Actividad", "Estado Subdecano", "Delegado","Estado Coordinador"];

const options = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Atendidas' },
    { value: '2', label: 'Parcialmente Atendidas' },
    { value: '3', label: 'Pendientes' }
]

const optionsDelegacion = [
    { value: '0', label: 'Todos' },
    { value: '1', label: 'Delegados' },
    { value: '2', label: 'No delegados' }
]


class ListadoCargaReporteSubdecanos extends React.Component {
    constructor(props) {
        super(props);
        const cargaList = this.props.carga;
        const roles = this.props.rol
        /*console.log(cargaList);*/
        this.state = {
            loading: true,
            actividades: cargaList,
            actividadesMutar: cargaList,
            currentActividades: [],
            currentPage: 1,
            totalPages: null,
            delegacionSelect: 'Todos',
            tipoSelect: 'Todos',
            filterDelegacion: 0,            
            filterTipo: 0,
            roles: roles,            
            totalPageP: Math.ceil(cargaList.length / 10),
            actualPage: 1,
            limite: 10,
            siblingCount: 1,
            subdecanos: [],
        };

        //fetch(local + 'Administrador/GetSubdecanos', {
        //    method: 'GET'
        //}).then(response => response.json())
        //    .then(data => {
        //        console.log("Unidades", data)
        //        this.setState({ subdecanos: data })
        //    }).catch(function F(error) {
        //        console.log(error);
        //    });

        this.page = this.page.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
        this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
        //console.log(window.location.pathname);
    }

    returnStatus = act => {
        return act.strEstado == 'AD' || act.strEstado == 'AV' ? "rd" :
            act.strEstado == 'RD' || act.strEstado == 'RV' || act.strEstado == 'R' || act.strEstado == 'RA' ? "pe" :
            act.strEstado == 'ED' || act.strEstado == 'EDC' || act.strEstado == 'EV' ? "pa" :
            act.strEstado == 'P' ? "pe" : "at"
    }

    redirect = idPersona => {
        /*console.log('alola')*/
        this.props.history.push('/profesorAdministrador/' + idPersona)
    }

    page(num) {
        if (this.state.actualPage !== num) {
            this.setState({
                actualPage: num
            });
        }
    }

    pagePrevious() {
        if (this.state.actualPage !== 1) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p - 1
            });
        }
    }

    pageNext() {
        if (this.state.actualPage !== this.state.totalPageP) {
            let p = this.state.actualPage;
            this.setState({
                actualPage: p + 1
            });
        }
    }

    youAreMySibling(num) {
        let actualPage = this.state.actualPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageP;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage) ){
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage )) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        /*console.log(num, valor);*/
        return valor;
    }

    handleDownloadExcel() {
        //console.log(this.state.actividadesMutar);
        downloadExcel({
            fileName: "Reporte Subdecano",
            sheet: "Reporte",
            tablePayload: {
                header,
                // accept two different data structures
                body: this.state.actividadesMutar,
            },
        });
    }

    handleChangeTipo = selectedOption => {
        /*console.log(`Option selected:`, selectedOption);*/

        const value = parseInt(selectedOption.value);
        this.setState({ filterTipo: value, tipoSelect: selectedOption.label });
        const { filterDelegacion } = this.state;
        let mapeo = this.state.actividades;
        /*console.log("MAPEO", mapeo);*/
        if (filterDelegacion === 1) {
            mapeo = mapeo.filter(x => x.cantAccionesCoor > 0)
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor == x.accionesIngresadasCoor);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadasCoor === 0 && x.cantAccionesCoor !== 0 && x.cantAccionesCoor > 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor > 1 && x.accionesIngresadasCoor >= 1);
            }
        }
        else if (filterDelegacion === 2) {
            if (filterDelegacion === 2)
                mapeo = mapeo.filter(x => x.cantAccionesCoor === 0)
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones == x.accionesIngresadas && x.cantAcciones > 0);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas === 0 && x.cantAcciones !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones > 1 && x.accionesIngresadas >= 1 && x.cantAcciones > x.accionesIngresadas);
            }
        } else if (filterDelegacion === 0) {
            if (value === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones + x.cantAccionesCoor == x.accionesIngresadas + x.accionesIngresadasCoor && x.cantAcciones > 0);
            }
            else if (value === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas + x.accionesIngresadasCoor === 0 && x.cantAcciones + x.cantAccionesCoor !== 0);
            }
            else if (value === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones + x.cantAccionesCoor > 1 && x.accionesIngresadas + x.accionesIngresadasCoor >= 1 && x.cantAcciones + x.cantAccionesCoor > x.accionesIngresadas + x.accionesIngresadasCoor);
            }
        }
        
        this.setState({ actividadesMutar: mapeo, actualPage: 1 });
        this.reLoadTotalPage(mapeo.length, this.state.limite);
    };

    handleChangeNombre = selectedOption => {
        const { value, label } = selectedOption;
        let mapeo = []
        if (value === 0) {           
            this.handleChangeTipo({ label: "Todos", value: this.state.filterTipo });
        } else {
            mapeo = this.state.actividades.filter(x => x.nombreCompleto === value);
            this.setState({ actividadesMutar: mapeo, actualPage: 1 });
            this.reLoadTotalPage(mapeo.length, this.state.limite);
        }
    };

    handleChangeDelegado = selectedOption => {
        const { value, label } = selectedOption;
        let mapeo = []
        if (value === 0) {
            this.handleChangeTipo({ label: "Todos", value: this.state.filterTipo });
        } else {
            mapeo = this.state.actividades.filter(x => x.delegado === value);
            this.setState({ actividadesMutar: mapeo, actualPage: 1 });
            this.reLoadTotalPage(mapeo.length, this.state.limite);
        }
    };

    handleChangeUnidad = selectedOption => {
        const { value, label } = selectedOption;
        let mapeo = []
        //if (value === 0) {
        //    this.handleChangeTipo({ label: "Todos", value: this.state.filterTipo });
        //} else {
        //    mapeo = this.state.actividades.filter(x => x.strUnidad === value);
        //    this.setState({ actividadesMutar: mapeo, actualPage: 1 });
        //    this.reLoadTotalPage(mapeo.length, this.state.limite);
        //}

    };

    handleChangeDelegacion = selectedOption => {
        /*console.log(`Option selected:`, selectedOption);*/

        const value = parseInt(selectedOption.value);
        this.setState({ filterDelegacion: value, delegacionSelect: selectedOption.label });
        const { filterTipo } = this.state;
        let mapeo = this.state.actividades;
        if (value === 1) {
            mapeo = mapeo.filter(x => x.cantAccionesCoor > 0)
            if (filterTipo === 1) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor == x.accionesIngresadasCoor);
            }
            else if (filterTipo === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadasCoor === 0 && x.cantAccionesCoor !== 0);
            }
            else if (filterTipo === 2) {
                mapeo = mapeo.filter(x => x.cantAccionesCoor > 1 && x.accionesIngresadasCoor >= 1);
            }
        }
        else if (value === 2 || value === 0) {
            if (value === 2)
                mapeo = mapeo.filter(x => x.cantAccionesCoor === 0)
            if (filterTipo === 1) {
                mapeo = mapeo.filter(x => x.cantAcciones == x.accionesIngresadas);
            }
            else if (filterTipo === 3) {
                mapeo = mapeo.filter(x => x.accionesIngresadas === 0 && x.cantAcciones !== 0);
            }
            else if (filterTipo === 2) {
                mapeo = mapeo.filter(x => x.cantAcciones > 1 && x.accionesIngresadas >= 1 && x.cantAcciones > x.accionesIngresadas);
            }
        }
        //console.log("FILTER TIPO: ", filterTipo)
        //console.log("MAPEO POS FILTER TIPO: ", mapeo)
        //const currentActividades = mapeo.slice(0, 0 + limite);
        //console.log(currentActividades);
        //this.setState({ currentActividades: currentActividades, totalRecords: currentActividades.length, actividadesMutar: mapeo });
        this.setState({ actividadesMutar: mapeo, actualPage: 1 });
        this.reLoadTotalPage(mapeo.length, this.state.limite);
    };

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageP: Math.ceil(lenActividades / limite) });
        /*console.log('Total Paginas: ',this.state.totalPageA);*/
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num, actualPage: 1 });
        this.reLoadTotalPage(this.state.actividadesMutar.length, num);
    }

    render() {
        let { actividadesMutar, actividades, filterTipo, subdecanos } = this.state;

        let xmCol = 'col-2';

        let jumpP = '<<';
        let jumpN = '>>';

        if (actividadesMutar !== null) {
            /*console.log("OG", actividadesMutar)*/
            actividadesMutar.sort((a, b) => {
                if (a.strEstado > b.strEstado) { return -1; }
                if (a.strEstado < b.strEstado) { return 1; }
            })
            /*console.log("UPDATED", actividadesMutar)*/
        }        

        let nombres = actividadesMutar === null || Object.keys(actividadesMutar).length === 0 ? [] : actividadesMutar.map(x => ( x.nombreCompleto));

        const nombrado = [];

        for (var i = 0; i < nombres.length; i++) {

            const elemento = nombres[i];

            if (!nombrado.includes(nombres[i])) {
                nombrado.push(elemento);
            }
        }

        let nombresText = []

        for (var i = 0; i < nombrado.length; i++) {
            const elemento = nombrado[i];
            nombresText.push({ label: elemento, value: elemento })
        }

        let delegados = actividadesMutar === null || Object.keys(actividadesMutar).length === 0 ? [] : actividadesMutar.map(x => (x.delegado));

        const delegado = [];

        for (var i = 0; i < delegados.length; i++) {

            const elemento = delegados[i];

            if (!delegado.includes(delegados[i])) {
                delegado.push(elemento);
            }
        }

        let delegadosText = []

        for (var i = 0; i < delegado.length; i++) {
            const elemento = delegado[i];
            delegadosText.push({ label: elemento, value: elemento })
        }

        //let unidades = actividadesMutar === null || Object.keys(actividadesMutar).length === 0 ? []
        //    : actividadesMutar.map(x => (x.strUnidad));

        //const unicos = [];

        //for (var i = 0; i < unidades.length; i++) {

        //    const elemento = unidades[i];

        //    if (!unicos.includes(unidades[i])) {
        //        unicos.push(elemento);
        //    }
        //}

        let unidadText = subdecanos === null || Object.keys(subdecanos).length === 0 ? [] : subdecanos.map(x => ({ label: x.nombreFinal, value: x.idSubdecano }));

        //for (var i = 0; i < unicos.length; i++) {
        //    const elemento = unicos[i];
        //    unidadText.push({ label: elemento, value: elemento })
        //}

        /*console.log(filterTipo)*/
        if (filterTipo === 0) {
            /*console.log("OG", actividadesMutar)*/
            actividadesMutar.sort((a, b) => {
                if (a.strEstado > b.strEstado) { return -1; }
                if (a.strEstado < b.strEstado) { return 1; }
            })
            /*console.log("UPDATED", actividadesMutar)*/
        }

        nombresText.push({ label: "Todos", value: 0 });

        unidadText.push({ label: "Todos", value: 0 });

        delegadosText.push({ label: "Todos", value: 0 });

        /*console.log(unidadText);*/

        let pagesA = [];
        for (let i = 1; i <= this.state.totalPageP; i++) {
            pagesA.push(<></>);
        }

        return (
            <>
                <Row>
                    <Col xs="4">
                        <label>
                            Nombre/Apellido:
                        </label>
                        <Select name="nombre"
                            options={nombresText}
                            value={this.state.nombre}
                            onChange={this.handleChangeNombre} />
                    </Col>
                    <Col xs="4">
                        {/*<>*/}
                        {/*    <label>*/}
                        {/*        Subdecano*/}
                        {/*    </label>*/}
                        {/*    <Select name="Subdecano"*/}
                        {/*        options={unidadText}*/}
                        {/*        value={this.state.unidad}*/}
                        {/*        onChange={this.handleChangeUnidad} />*/}
                        {/*</>                        */}
                    </Col>
                    <Col xs="4">
                        <>
                            <label>
                                Delegado
                            </label>
                            <Select name="delegado"
                                options={delegadosText}
                                value={this.state.unidad}
                                onChange={this.handleChangeDelegado} />
                        </>
                    </Col>
                </Row>
                <br />
                {/*<Button onClick={this.handleDownloadExcel}>Descargar Excel</Button>*/}
                {/*<br />*/}
                <Row hidden={actividadesMutar.length === 0} id={'newPagination'}>
                    <Col xs="4"><Button onClick={this.handleDownloadExcel}>Descargar Excel</Button></Col>
                    <Col xs="4"></Col>                    
                    <Col>
                        <Pagination hidden={pagesA.length < 1 } >                            
                            <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                <PaginationLink>
                                    {1}
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                <PaginationLink previous />
                            </PaginationItem>
                            {pagesA.map((page, i) =>
                            (
                                <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.youAreMySibling(i+1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                    <PaginationLink>
                                        {i + 1}
                                    </PaginationLink>
                                </PaginationItem>)
                            )}
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === this.state.totalPageP } onClick={() => { this.pageNext(); }}>
                                <PaginationLink next />
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.actualPage === this.state.totalPageP} onClick={() => { this.page(this.state.totalPageP); }}>
                                <PaginationLink>
                                    {this.state.totalPageP}
                                </PaginationLink>
                            </PaginationItem>                            
                        </Pagination>
                    </Col>
                    <Col xs="1">
                        <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                            <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                            <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                            <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                            <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                        </Input>
                    </Col>
                </Row>
                <div id="cartasListDecano">
                    <Card>
                        <CardHeader style={{}} hidden={actividadesMutar.length === 0} >
                            <Container fluid>
                                <Row>                                    
                                    <Col className='col-3'>
                                        Profesor
                                    </Col>
                                    <Col className='col-5'>
                                        Actividad
                                    </Col>
                                    <Col className='col-2'>
                                        Delegado a
                                    </Col>
                                    <Col className='col-2'>
                                        Estado
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                    </Card>
                    {actividadesMutar.map((profesor, i) =>
                        <Card hidden={!(this.state.actualPage === Math.ceil((i + 1) / this.state.limite))}>
                            <CardHeader>
                                <Button className="btnProf" onClick={() => this.redirect(profesor.intIdPersona)}>

                                    <Container fluid>
                                        <Row>                                           
                                            <Col className='col-3' style={{ textAlign: 'center' }}>
                                                {profesor.nombreCompleto}
                                            </Col>
                                            <Col className='col-5' style={{ textAlign: 'center' }}>
                                                {profesor.actividad}
                                            </Col>
                                            <Col className='col-2' style={{ textAlign: 'center' }}>
                                                {profesor.delegado}
                                            </Col>
                                            <Col className='col-2' style={{ textAlign: 'center' }}>
                                                {profesor.estadoObservacion}
                                            </Col>
                                        </Row>
                                    </Container>

                                </Button>

                            </CardHeader>
                        </Card>
                    )}
                    {actividadesMutar.length === 0 ? 
                        <Card body className="text-center py-3">No hubo resultados</Card>
                        : <></>}
                </div>
                <br />
                <Row hidden={actividadesMutar.length === 0}>
                    <Col xs="8"></Col>                    
                    <Col>
                        <Pagination hidden={pagesA.length < 1} >
                            <PaginationItem active={this.state.actualPage === 1} onClick={() => { this.page(1); }}>
                                <PaginationLink>
                                    {1}
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === 1} onClick={() => { this.pagePrevious(); }}>
                                <PaginationLink previous />
                            </PaginationItem>
                            {pagesA.map((page, i) =>
                            (
                                <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.youAreMySibling(i + 1)} active={this.state.actualPage === i + 1} onClick={() => { this.page(i + 1); }}>
                                    <PaginationLink>
                                        {i + 1}
                                    </PaginationLink>
                                </PaginationItem>)
                            )}
                            <PaginationItem hidden={this.state.totalPageP < 5 || this.state.actualPage === this.state.totalPageP} onClick={() => { this.pageNext(); }}>
                                <PaginationLink next />
                            </PaginationItem>
                            <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.actualPage === this.state.totalPageP} onClick={() => { this.page(this.state.totalPageP); }}>
                                <PaginationLink>
                                    {this.state.totalPageP}
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </Col>
                    <Col xs="1">
                        <Input className="col-md-6" style={{ width: '5vw' }} type="select" onChange={this.onChangeLimite} value={this.state.limite} >
                            <option hidden key={"sel-1"} selected={1 == this.state.limite} value={1}>{1}</option>
                            <option key={"sel-5"} selected={5 == this.state.limite} value={5}>{5}</option>
                            <option key={"sel-10"} selected={10 == this.state.limite} value={10}>{10}</option>
                            <option key={"sel-25"} selected={25 == this.state.limite} value={25}>{25}</option>
                        </Input>
                    </Col>
                </Row>
            </>
        )
    }
}
export default withRouter(ListadoCargaReporteSubdecanos);